function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(410 1)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#262C37",
  strokeDasharray: "4,4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.25,
  strokeWidth: 2,
  d: "M40 0a8.302 8.302 0 018.302 8.302v63.396a8.302 8.302 0 11-16.604 0V8.302A8.302 8.302 0 0140 0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#262C37",
  strokeDasharray: "4,4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.25,
  strokeWidth: 2,
  d: "M80 40a8.302 8.302 0 01-8.302 8.302H8.302a8.302 8.302 0 110-16.604h63.396A8.302 8.302 0 0180 40z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 3.019,
  fill: "#262C37",
  fillOpacity: 0.25
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#262C37",
  strokeDasharray: "4,4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.15,
  strokeWidth: 2,
  d: "M68.284 11.716a8.302 8.302 0 010 11.74L23.456 68.284a8.302 8.302 0 11-11.74-11.74l44.828-44.828a8.302 8.302 0 0111.74 0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#262C37",
  strokeDasharray: "4,4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.15,
  strokeWidth: 2,
  d: "M68.284 68.284a8.302 8.302 0 01-11.74 0L11.716 23.456a8.302 8.302 0 1111.74-11.74l44.828 44.828a8.302 8.302 0 010 11.74z"
}));

function SvgSeparate3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 82
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iODIiIHZpZXdCb3g9IjAgMCA5MDAgODIiPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MTAgMSkiPgogICAgICAgICAgICA8cGF0aCBzdHJva2U9IiMyNjJDMzciIHN0cm9rZS1kYXNoYXJyYXk9IjQsNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utb3BhY2l0eT0iLjI1IiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik00MCAwYTguMzAyIDguMzAyIDAgMCAxIDguMzAyIDguMzAydjYzLjM5NmE4LjMwMiA4LjMwMiAwIDEgMS0xNi42MDQgMFY4LjMwMkE4LjMwMiA4LjMwMiAwIDAgMSA0MCAweiIvPgogICAgICAgICAgICA8cGF0aCBzdHJva2U9IiMyNjJDMzciIHN0cm9rZS1kYXNoYXJyYXk9IjQsNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utb3BhY2l0eT0iLjI1IiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik04MCA0MGE4LjMwMiA4LjMwMiAwIDAgMS04LjMwMiA4LjMwMkg4LjMwMmE4LjMwMiA4LjMwMiAwIDEgMSAwLTE2LjYwNGg2My4zOTZBOC4zMDIgOC4zMDIgMCAwIDEgODAgNDB6Ii8+CiAgICAgICAgICAgIDxjaXJjbGUgY3g9IjQwIiBjeT0iNDAiIHI9IjMuMDE5IiBmaWxsPSIjMjYyQzM3IiBmaWxsLW9wYWNpdHk9IjAuMjUiIC8+CiAgICAgICAgICAgIDxwYXRoIHN0cm9rZT0iIzI2MkMzNyIgc3Ryb2tlLWRhc2hhcnJheT0iNCw0IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1vcGFjaXR5PSIuMTUiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTY4LjI4NCAxMS43MTZhOC4zMDIgOC4zMDIgMCAwIDEgMCAxMS43NEwyMy40NTYgNjguMjg0YTguMzAyIDguMzAyIDAgMSAxLTExLjc0LTExLjc0bDQ0LjgyOC00NC44MjhhOC4zMDIgOC4zMDIgMCAwIDEgMTEuNzQgMHoiLz4KICAgICAgICAgICAgPHBhdGggc3Ryb2tlPSIjMjYyQzM3IiBzdHJva2UtZGFzaGFycmF5PSI0LDQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW9wYWNpdHk9Ii4xNSIgc3Ryb2tlLXdpZHRoPSIyIiBkPSJNNjguMjg0IDY4LjI4NGE4LjMwMiA4LjMwMiAwIDAgMS0xMS43NCAwTDExLjcxNiAyMy40NTZhOC4zMDIgOC4zMDIgMCAxIDEgMTEuNzQtMTEuNzRsNDQuODI4IDQ0LjgyOGE4LjMwMiA4LjMwMiAwIDAgMSAwIDExLjc0eiIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgSeparate3 as ReactComponent };